<template>
  <div class="timer-display" :class="[fontAdjustClass, { 'has-bg': showBg }]" :style="displayStyle">
    <h1>
      <span v-if="timerSign" class="timer-sign">{{ timerSign }}</span>
      <span v-if="timerHours" class="timer-digits">{{ timerHours }}</span>
      <span v-if="timerHours" class="timer-colon">:</span>
      <span class="timer-digits">{{ timerMinutes }}</span>
      <span class="timer-colon">:</span>
      <span class="timer-digits">{{ timerSeconds }}</span>
    </h1>
  </div>
</template>

<script>
import timerMixin, { TIMER_KEYS, DEFAULT_FONT, fontAdjustClass } from '../mixins/simpleTimer'

export default {
  mixins: [timerMixin],
  props: {
    // 後方互換: URLクエリ ?font= が来た場合の初期値として扱う（通常はlocalStorageを使用）
    font: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedFont: this.font || DEFAULT_FONT,
      showBg: true,
      selectedPreset: 0
    }
  },
  computed: {
    colorPreset() {
      return this.colorPresets[this.selectedPreset] || this.colorPresets[0];
    },
    fontAdjustClass() {
      return fontAdjustClass(this.selectedFont);
    },
    displayStyle() {
      const style = {
        fontFamily: this.selectedFont,
        color: this.colorPreset.text
      };
      if (this.showBg) {
        style.backgroundColor = this.colorPreset.bg;
        style.border = `0.12em solid ${this.colorPreset.border}`;
        style.borderRadius = '0.12em';
      }
      return style;
    },
  },
  methods: {
    handleStorageChange(event) {
      switch (event.key) {
        case TIMER_KEYS.seconds:
          this.totalSeconds = parseInt(event.newValue || '0');
          break;
        case TIMER_KEYS.showBg:
          this.showBg = event.newValue !== 'false';
          break;
        case TIMER_KEYS.presetIndex:
          this.applyPresetIndex(event.newValue);
          break;
        case TIMER_KEYS.font:
          if (event.newValue) this.selectedFont = event.newValue;
          break;
      }
    },
    applyPresetIndex(value) {
      const idx = parseInt(value);
      if (!isNaN(idx) && idx >= 0 && idx < this.colorPresets.length) {
        this.selectedPreset = idx;
      }
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
    this.totalSeconds = parseInt(localStorage.getItem(TIMER_KEYS.seconds) || '0');
    this.showBg = localStorage.getItem(TIMER_KEYS.showBg) !== 'false';
    const savedPreset = localStorage.getItem(TIMER_KEYS.presetIndex);
    if (savedPreset !== null) this.applyPresetIndex(savedPreset);
    const savedFont = localStorage.getItem(TIMER_KEYS.font);
    if (savedFont) this.selectedFont = savedFont;
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oxanium:wght@200..800&display=swap');

.timer-display {
  font-size: 5rem;
  text-align: center;
  display: inline-block;
  padding: 0.18em 0.6em;
  line-height: 1;
}

.timer-display h1 {
  margin: 0;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* フォントメトリクス上グリフが上に寄るため下方向に補正 */
.timer-display.font-josefin h1 > span {
  transform: translateY(0.09em);
}

.timer-display.font-oxanium h1 > span {
  transform: translateY(0.05em);
}

.timer-digits {
  display: inline-block;
  width: 2.1ch;
  text-align: center;
  vertical-align: bottom;
}

.timer-colon {
  display: inline-block;
  width: 0.7ch;
  text-align: center;
  opacity: 0.8;
  vertical-align: bottom;
}

.timer-sign {
  display: inline-block;
  width: 0.7ch;
  text-align: center;
  vertical-align: bottom;
}
</style>